import ManagerContainer from "./ManagerListContainer";

export default ManagerContainer;
